<template>
    <div class="forum-items">
        <div class="forum-box" @click="goDetails(item.post.id)">
            <div class="forum-box-title">{{item.post.title}}</div>
            <div class="forum-box-content">
                <img :src="item.post.images?item.post.images[0]:''" alt="" v-if="item.post.images">
                <div class="forum-box-content-item"><span>{{richTextFormat}}</span><span class="lookDetails" v-if="richTextFormat.length>290">查看详情</span></div>
            </div>
            <!-- 我的评论 -->
            <div class="forum-box-comment">
                <div class="forum-box-comment-box">
                    <img :src="item.user.avatar" alt="">
                    <div class="forum-box-comment-box-right">
                        <!-- 头部 -->
                        <div class="forum-box-comment-box-right-user">
                            <span>{{item.user?item.user.nickname:''}}</span><span>{{item.dateTime}}</span>
                        </div>
                        <!-- 内容 -->
                        <div class="forum-box-comment-box-right-content">{{item.content}}</div>
                        <!-- 操作 -->
                        <div class="forum-box-comment-box-right-operation">
                            <div class="forum-box-comment-box-right-operation-box" @click.stop="commentLove(item.id)">
                                <img v-if="item.is_like==0 || !item.is_like" src="../../assets/image/like.png" alt="">
                                <img v-else src="../../assets/image/checkLike.png" alt="">
                                <!-- <img src="../../assets/image/like.png" alt=""> -->
                                <span>{{item.like_num}}</span>
                            </div>
                            <div class="forum-box-comment-box-right-operation-box" @click.stop="del(item.id)">
                                <img src="../../assets/image/del.png" alt="">
                                <span>删除</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        operation:{
            type:Boolean,
            default:true
        },
        item:{
            type:Object,
            default:null
        },
        isDel:{
            type:Boolean,
            default:false
        }
    },
    computed:{
        richTextFormat() {
            let value=this.item.post.content
            if (value.length > 290) {
                return value.slice(0, 290) + "...";
            }
            return value;
        },
    },
    methods:{
        commentLove(id){
            this.$emit('commentLove',id)
        },
        goDetails(id){
            this.$emit('goDetails',id)
        },
        del(id){
            this.$emit('del',id)
        }
    }
}
</script>
<style lang="scss">
.forum-items{
    .forum-box{
        border-bottom: 1px solid #F9FAFD;
        padding: 20px 0;
        .forum-box-title{
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #1E2134;
            line-height: 30px;
        }
        .forum-box-content{
            margin: 15px 0 20px 0;
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: flex-start;
            img{
                width: 240px;
                height: 145px;
                border-radius: 4px;
            }
            .forum-box-content-item{
                margin-left: 20px;
                span{
                    font-size: 18px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    line-height: 30px;
                    color: #1E2134;
                    // display: -webkit-box; 
                    // -webkit-box-orient: vertical; 
                    // -webkit-line-clamp: 4; 
                    // overflow: hidden;
                }
                .lookDetails{
                    white-space: nowrap;
                    font-size: 18px;
                    color: #3D7EFF;
                }
            }
        }
         .forum-box-comment{
            .forum-box-comment-box{
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: flex-start;
                img{
                    width: 55px;
                    height: 55px;
                    border-radius: 50%;
                }
                .forum-box-comment-box-right{
                    padding: 10px 0 0 0;
                    margin-left: 12px;
                    .forum-box-comment-box-right-user{
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: flex-start;
                        span{
                            &:nth-child(1){
                                font-size: 18px;
                                font-family: PingFangSC-Medium, PingFang SC;
                                font-weight: 500;
                                color: #1E2134;
                            }
                            &:nth-child(2){
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #858585;
                                margin-left: 26px;
                            }
                        }
                    }
                    .forum-box-comment-box-right-content{
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #1E2134;
                        margin: 8px 0 15px 0;
                    }
                    .forum-box-comment-box-right-operation{
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        .forum-box-comment-box-right-operation-box{
                            cursor: pointer;
                            display: flex;
                            flex-direction: row;
                            justify-content: flex-start;
                            align-items: center;
                            margin-right: 20px;
                            img{
                                width: 20px;
                                height: 20px;
                            }
                            span{
                                font-size: 16px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #506176;
                                margin-left: 5px;
                            }
                        }
                    }
                }
            }
        }
        .forum-box-msg{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center; 
            .forum-box-msg-user{
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                img{
                    width: 30px;
                    height: 30px;
                    border-radius: 50%;
                }
                .forum-box-msg-user-name{
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #1E2134;
                    margin: 0 15px 0 10px;
                }
                .forum-box-msg-user-time{
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #858585;
                }
            }
            .forum-box-msg-comment{
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                .forum-box-msg-comment-box{
                    cursor: pointer;
                    margin-left: 20px;
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    img{
                        width: 20px;
                        height: 20px;
                    }
                    div{
                        font-size: 16px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #506176;
                        margin-left: 8px;
                    }
                }
            }
        }
    }
}
</style>